import { useParams } from 'react-router-dom';
import SEOMeta from '@/components/base/SEOMeta';
import SchemaOrg from '@/components/base/SchemaOrg';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ComicCard from '@/components/feature/ComicCard';
import { comics } from '@/mocks/comics';
import { categories, categoryNames, categoryDescriptions } from '@/mocks/categories';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();

  const currentCategory = categories.find((c) => c.slug === slug);
  const catName = currentCategory ? currentCategory.name : slug;
  const catDescription = slug ? categoryDescriptions[slug] || '' : categoryDescriptions.all;

  const filteredComics = slug && slug !== 'all'
    ? comics.filter((c) => c.category === slug)
    : comics;

  const pageTitle = slug && slug !== 'all'
    ? `${catName}漫画 - 韩国${catName}漫画推荐`
    : '全部漫画 - 韩国漫画大全';

  return (
    <>
      <SEOMeta
        title={pageTitle}
        description={catDescription}
        keywords={`韩国${catName}漫画,${catName}韩漫推荐,韩国漫画大全,韩漫漫画网`}
        canonicalUrl={`https://www.hanmancomic.com/category/${slug || 'all'}`}
      />
      <SchemaOrg
        pageType="WebPage"
        breadcrumbs={[
          { name: '首页', url: '/' },
          { name: catName ? `${catName}漫画` : '全部漫画', url: `/category/${slug || 'all'}` },
        ]}
      />

      <Navbar />

      <main className="min-h-screen">
        <div className="px-4 md:px-6 py-6 md:py-8 max-w-6xl mx-auto">
          <Breadcrumb
            items={[
              { name: '首页', url: '/' },
              { name: catName ? `${catName}漫画` : '全部漫画', url: `/category/${slug || 'all'}` },
            ]}
          />

          <div className="mb-6 md:mb-8">
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              {slug && slug !== 'all' ? `${catName}漫画` : '韩国漫画大全'}
            </h1>
            <p className="mt-2 text-sm md:text-base text-foreground-600">
              {catDescription}
            </p>
          </div>

          <div className="flex items-center gap-2 md:gap-3 mb-6 md:mb-8 flex-wrap">
            {categories.map((cat) => (
              <a
                key={cat.slug}
                href={`/category/${cat.slug}`}
                className={`px-3 py-1.5 md:px-4 md:py-2 text-xs md:text-sm font-medium rounded-full transition-colors cursor-pointer whitespace-nowrap ${
                  (slug || 'all') === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 text-foreground-700 border border-background-200/70 hover:border-primary-300 hover:text-primary-600'
                }`}
              >
                {cat.name}
              </a>
            ))}
          </div>

          {filteredComics.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
              {filteredComics.map((comic) => (
                <ComicCard key={comic.id} comic={comic} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <i className="ri-inbox-line text-4xl text-foreground-300" />
              <p className="mt-4 text-foreground-500">该分类下暂无漫画，请浏览其他分类</p>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </>
  );
}